import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { AuthService } from '@/shared/services';

@Component({
  selector: 'about-page-main-content',
  templateUrl: './about-page-main-content.component.html',
  styleUrls: ['./about-page-main-content.component.css'],
  standalone: false,
})
export class AboutPageMainContentComponent implements OnInit {
  public date: string = 'Jun 13, 2025';
  public env = environment;
  public isStudent = this.authService.getRole() === 'student' ? true : false;
  public role = this.authService.getRole();

  constructor(public authService: AuthService) {
    if (this.role === 'student') {
      this.isStudent = true;
    } else {
      this.isStudent = false;
    }
  }

  ngOnInit(): void {}
}
